export const camelCaseToTitle = (str) => {
  // insert a space before all caps
  str = str.replace(/([A-Z])/g, ' $1')

  // capitalize the first letter and return the string
  const titleCaseString = str.charAt(0).toUpperCase() + str.slice(1)

  return titleCaseString.trim()
}

export const stringToSentence = (str) => {
  const capitalizedString = str?.toLowerCase()?.split(' ')?.map(str => str.charAt(0).toUpperCase() + str.slice(1))

  return capitalizedString?.join(' ')
}
